
    import { Component, Prop, Vue } from 'vue-property-decorator';
    import jspm from '@/services/PrintManager';

    @Component
    export default class DruckhinweisDialog extends Vue {
        @Prop() visible!: boolean;

        public printerStatus(): string {
            return jspm.printerStatus();
        }
    }
